module.exports = __webpack_public_path__ + "img/TheAdventuresOfLanceleau_5006x12300.2de4041e.png";